import React, { FC, useEffect, useState } from 'react';

import { FormikProps } from 'formik';

import { Box, SxProps, Typography } from '@mui/material';

import genericClasses from '../../../theme/GenericClasses';

import { ReactComponent as UploadIcon } from '../../../assets/svg/uploadCloud.svg';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { setDialog } from '../../../reducers/dialogReducer';
import { Constants } from '../../../helpers/Constants';
import useFileUpload, {
  fileUploadTypes,
} from '../../../hooks/FileUpload/useFileUpload';
import CustomButton from '../CustomButton';
import FormikError from '../FormikError';

import FileUpload from './FileUpload';
import styles from './styles';

interface IFileUploadButton {
  formik: FormikProps<any>;
  fileUploadType: fileUploadTypes;
  customClass: SxProps;
  name: string;
}

interface ILocalFile {
  url: string;
  name: string;
}

const FileUploadButton: FC<IFileUploadButton> = ({
  formik,
  fileUploadType,
  customClass,
  name,
}) => {
  const dispatch = useAppDispatch();
  const [file, setFile] = useState<ILocalFile | null>(null);
  const { label, fileName, onSuccess, uploadSuccess } = useFileUpload(fileUploadType) ?? {};

  const showFileUploadModal = () => {
    dispatch(
      setDialog({
        maxWidth: 'xs',
        showCloseButton: true,
        Component: (
          <FileUpload file={file} setFile={setFile} type={fileUploadType} />
        ),
        heading: {
          title: label,
        },
      }),
    );
  };

  useEffect(() => {
    if (uploadSuccess) {
      onSuccess?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadSuccess]);

  const displayName = file?.name || fileName || '\u00A0';
  const isResume = fileUploadType === fileUploadTypes.resume;

  return (
    <Box
      onClick={showFileUploadModal}
      sx={[genericClasses.button, isResume ? { mt: 0.5 } : { mt: '-10px' }, customClass] as SxProps}
    >
      <Typography
        sx={displayName.length > 1 ? genericClasses.imageName : styles.text}
      >
        {displayName}
      </Typography>
      <CustomButton
        customClass={styles.button}
        label={label}
        onClick={showFileUploadModal}
        variant={Constants.variant.outlined}
        startIcon={<UploadIcon />}
      />
      <FormikError formik={formik} name={name} />
    </Box>
  );
};

export default FileUploadButton;
